module.exports = __webpack_public_path__ + "static/media/76.eb4978a8.png";